module.exports = __webpack_public_path__ + "img/notifications.029e74fa.svg";